var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-filters"},_vm._l((_vm.tags),function(tag,i){return _c('div',{key:i,staticClass:"item",class:[{ active: _vm.status === tag }],attrs:{"data-tag":tag},on:{"click":_vm.onSelect}},[_vm._v(" "+_vm._s(tag)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }